import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core';

import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from '#root/components/ui';
import { CanguroGuvery } from '#root/assets';
import styles from './priceDialog.module.scss';

export interface PriceData {
  image?: string;
  name?: string;
  link?: string;
  can?: number | string | null;
  price?: number | string | null;
  comTraveler?: number | string | null;
  comGuvery?: number | string | null;
}

interface PriceDialogProps {
  open: boolean;
  onClose: () => void;
  priceData: PriceData;
}

const getDecimal = (num: number) => {
  const intNum = Number(num);
  return Math.round(intNum * 100) / 100;
};

/**
 * Detalle del total de una oferta, en Mis Pedidos y en el detalle del pedido.
 * Lo comparten `UserOrders/OrderCard` y `UserOrderDetail/OfferItem`.
 */
const PriceDialog = (props: PriceDialogProps) => {
  const { open = false, onClose, priceData } = props;
  const priceReal = Number(priceData.price);
  const comTraveler = Number(priceData.comTraveler);
  const comGuvery = Number(priceData.comGuvery);
  const total = priceReal + comTraveler + comGuvery;

  return (
    <Modal open={open} onClose={onClose}>
      <ModalHeader>
        <ModalTitle>Detalle del total</ModalTitle>
      </ModalHeader>
      <ModalBody flush>
        <div className={styles.product}>
          <div className={styles.cover}>
            {priceData.image ? (
              <img className={styles.img} src={priceData.image} alt="producto" />
            ) : (
              <img className={styles.holder} src={CanguroGuvery} alt="producto" />
            )}
          </div>
          <div className={styles.info}>
            <p className={styles.name}>{priceData.name}</p>
            <a href={priceData.link} target="_blank" rel="noopener noreferrer">
              <p className={styles.link}>{priceData.link}</p>
            </a>
          </div>
        </div>
        <TableContainer>
          <Table className={styles.table}>
            <TableHead className={styles.header}>
              <TableRow>
                <TableCell>Nombre</TableCell>
                <TableCell>Cantidad</TableCell>
                <TableCell>Total</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>Precio Real</TableCell>
                <TableCell>{priceData.can}</TableCell>
                <TableCell>$ {getDecimal(priceReal)}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Comisión</TableCell>
                <TableCell></TableCell>
                <TableCell>$ {getDecimal(comTraveler)}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Guvery (%)</TableCell>
                <TableCell></TableCell>
                <TableCell>$ {getDecimal(comGuvery)}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  <span className={styles.total}>Total</span>
                </TableCell>
                <TableCell></TableCell>
                <TableCell>
                  <span className={styles.total}>$ {getDecimal(total)}</span>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </ModalBody>
      <ModalFooter>
        <Button variant="outline" onClick={onClose}>
          Cerrar
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default PriceDialog;
